import { render, staticRenderFns } from "./confirmacion.vue?vue&type=template&id=79998d14"
import script from "./confirmacion.vue?vue&type=script&lang=js"
export * from "./confirmacion.vue?vue&type=script&lang=js"
import style0 from "./confirmacion.vue?vue&type=style&index=0&id=79998d14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports